module.exports = __webpack_public_path__ + "img/inicio.975ad8c7.svg";